import { useState } from 'react'
import { createPortal } from 'react-dom'
import { buttonVariants } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { imageUrl } from '../helpers'
import { useContrastedBackground } from './Card'

type Props = {
  className?: string
  withLabel?: boolean
  inSidebar?: boolean
  excludeGoogle?: boolean
  grow?: boolean
}

export const LOGIN_BUTTONS_COMPONENT_WIDTH = 257

const LoginButtons = ({
  className,
  withLabel = true,
  excludeGoogle = false,
  inSidebar = false,
  grow = false,
}: Props) => {
  const { t } = useTranslation()
  const [isLoggingIn, setIsLoggingIn] = useState(false)
  const backgroundColor = useContrastedBackground()

  return (
    <>
      <div
        className={cn(
          'flex',
          className,
          inSidebar ? 'flex-col w-full gap-2' : 'gap-1 items-center',
        )}
      >
        {withLabel && (
          <span
            className={cn(
              'mr-2 text-sm hidden sm:block',
              inSidebar ? 'text-center' : '',
            )}
          >
            {t('header.log-in-with')}
          </span>
        )}
        <a
          href='/auth/bnet'
          className={cn(
            buttonVariants({ variant: 'outline' }),
            backgroundColor,
            grow ? 'w-full' : '',
          )}
          onClick={() => setIsLoggingIn(true)}
        >
          <img src={imageUrl('bnet-logo-blue.svg')} className='w-5 sm:mr-2' />
          <span className='hidden sm:block'>Battle.net</span>
        </a>
        {!excludeGoogle && (
          <a
            href='/auth/google_oauth2'
            className={cn(
              buttonVariants({ variant: 'outline' }),
              backgroundColor,
              grow ? 'w-full' : '',
            )}
          >
            <img src={imageUrl('google-logo.svg')} className='w-5 sm:mr-2' />
            <span className='hidden sm:block'>Google</span>
          </a>
        )}
      </div>
      {isLoggingIn &&
        createPortal(
          <div className='fixed inset-0 z-50 flex flex-col items-center justify-center gap-8 bg-background/50 backdrop-blur-sm'>
            <div className='blizzard-spinner primary size64'>
              <div className='primary spinner-circle' />
            </div>
            <p className='text-base font-medium text-foreground'>
              {t('header.logging-in')}
            </p>
          </div>,
          document.body,
        )}
    </>
  )
}

export default LoginButtons
